import { getPreserveExpectedErrorsForCallerContext } from "../../../utils/apolloErrorPolicy";

export const CMP_MEMBER_PAST_TRANSITION_RECONCILIATION_REQUIRED_CODE =
  "CMP_MEMBER_PAST_TRANSITION_RECONCILIATION_REQUIRED";

export const memberPastTransitionApolloContext =
  getPreserveExpectedErrorsForCallerContext({
    expectedGraphQLErrorCodes: [
      CMP_MEMBER_PAST_TRANSITION_RECONCILIATION_REQUIRED_CODE,
    ],
  });
